module.exports = __webpack_public_path__ + "static/media/xResearchProject.35062bb5.png";